<template>
  <Broadcast :options="options"></Broadcast>
</template>

<script>
  import Broadcast from '../components/Broadcast';

  export default {
    components: { Broadcast },

    data() {
      const overrides = {
        theme: this.$route.query.theme,
        border: this.$route.query.border,
        cover: this.$route.query.cover,
        split: this.$route.query.split,
        follow: this.$route.query.follow,

        fontSize: this.$route.query['font-size'],
        fontFamily: this.$route.query['font-family'],
        
        picked: this.$route.query['picked'],
        optionsVisible: this.$route.query['options-visible'] && ['false', '0'].indexOf(this.$route.query['options-visible']) === -1
      }

      Object.keys(overrides).forEach(key => {
        if (overrides[key] === undefined) {
          delete overrides[key];
        }
      })

      const options = {
        theme: this.readOption('theme') || 'default',
        border: this.readOption('border') || 'default',
        cover: this.readOption('cover') || 'default',
        split: this.readOption('split') || 'default',
        follow: this.readOption('follow') || 'default',

        fontSize: Math.max(Math.min(+(this.readOption('fontSize') || '100'), 300), 50),
        fontFamily: this.readOption('fontFamily') || 'default',
      }

      return {
        options: Object.assign({}, options, overrides)
      }
    },

    watch: {
      options: {
        deep: true,

        handler(options) {
          this.$cookies.set('options', JSON.stringify(options))
        }
      }
    },

    methods: {
      readOption(option) {
        const cookie = this.$cookies.get('options');
        return cookie ? cookie[option] : null
      }
    }
  }
</script>